export default __webpack_public_path__ + "static/media/1186.5303f92e.png";